import { UserClientAvatar } from './user-client-avatar'

/** Signed-in user's avatar for the top bar. UserClientAvatar (a single
 * PersonAvatar) already handles image + identity-initials fallback, so
 * there is no Radix <Avatar> wrapper — that previously double-rendered
 * (image slot AND fallback slot) once the fallback became a real element
 * rather than Radix's own AvatarImage primitive. `size` is a Tailwind rem
 * step (w-7 = 28px). */
export function UserAvatar({ size = 7, marginTop = 0 }: { size?: number, marginTop?: number }) {
  return (
    <span className={`inline-flex flex-shrink-0 mt-${marginTop}`}>
      <UserClientAvatar size={size} />
    </span>
  )
}
